import React, { useEffect, useState } from "react";
import Layout from "../../common/layout";
import { useTranslation } from "react-i18next";
import ListTable from "../../../elements/list/list";
import { Container } from "../../common/layout/styels";

const InvoiceProducts = (props) => {
  const { t } = useTranslation();

  const [attributes] = useState([
    {
      type: "text",
      placeholder: "name",
      name: "name",
      validation: "",
      tab: "generalInfo",
      default: "",
      label: "name",
      required: true,
      filter: false,
      view: true,
      add: true,
      update: true
    },
    {
      type: "textarea",
      placeholder: "description",
      name: "description",
      validation: "",
      tab: "generalInfo",
      default: "",
      label: "description",
      required: false,
      filter: false,
      view: true,
      add: true,
      update: true
    },
    
    {
      type: "checkbox",
      placeholder: "active",
      tab: "generalInfo",
      name: "isActive",
      validation: "",
      showItem: "",
      default: "",
      label: "active",
      required: false,
      view: false,
      tag: false,
      add: true,
      update: true,
    },
    {
      type: "select",
      placeholder: "status",
      name: "isActive",
      tab: "generalInfo",
      validation: "",
      default: "",
      label: "status",
      required: false,
      view: true,
      filter: false,
      tag: true,
      add: false,
      update: false,
      apiType: "JSON",
      selectApi: [
        { id: true, value: t("active"), color: "green" },
        { id: false, value: t("inactive"), color: "red" },
      ],
    },
    {
      type: "date",
      placeholder: "createdAt",
      name: "createdAt",
      tab: "generalInfo",
      validation: "",
      default: "",
      label: "createdAt",
      required: false,
      view: true,
      filter: false,
      tag: true,
      add: false,
      update: false
    },
    ]);

  //to update the page title
  useEffect(() => {
    document.title = `${t("user")} - PersoBase`;
  }, [t]);
  const [priceAttributes] = useState([
    {
      type: "number",
      placeholder: "price",
      name: "price",
      validation: "",
      default: "",
      label: "price",
      required: true,
      view: true,
      add: true,
      update: true,
      filter: false,
    },
    {
      type: "select",
      placeholder: "currency",
      name: "currency",
      validation: "",
      default: "EUR",
      label: "currency",
      required: true,
      view: true,
      add: true,
      update: true,
      apiType: "JSON",
      selectApi: [
        { value: "EUR (€)", id: "EUR" },
        { value: "USD ($)", id: "USD" },
        { value: "INR (₹)", id: "INR" },
        { value: "GBP (£)", id: "GBP" },
        { value: "CHF (CHF)", id: "CHF" },
        { value: "AED (د.إ)", id: "AED" },
      ],
      filter: false,
    },
    {
      type: "date",
      placeholder: "valid from",
      tab: "official",
      name: "validFrom",
      validation: "date",
      default: "empty",
      label: "valid from",
      required: true,
      view: true,
      tag: true,
      add: true,
      update: true,
      filter: false,
    },
    {
      type: "date",
      placeholder: "valid until",
      name: "validUntil",
      tab: "official",
      validation: "date",
      default: "empty",
      label: "valid until",
      required: false,
      view: true,
      tag: true,
      add: true,
      update: true,
      filter: false,
    },
    {
      type: "checkbox",
      placeholder: "appliesToExistingCustomers",
      tab: "",
      name: "appliesToExistingCustomers",
      validation: "",
      showItem: "",
      default: "",
      label: "appliesToExistingCustomers",
      required: false,
      view: true,
      tag: true,
      add: true,
      update: true,
    },
  ]);

  const [actions] = useState([
    {
      element: "button",
      type: "subList",
      id: "productPrice",
      itemTitle: "",
      icon: "money",
      title: "productPrice",
      attributes: priceAttributes,
      params: {
        api: `product-price`,
        itemTitle: "",
        shortName: "productPrice",
        addPrivilege: true,
        delPrivilege: false,
        updatePrivilege: true,
        datefilter: false,
        customClass: "medium",
        formMode: "double"
      },
    },
   ]);

  // Use the useTranslation hook from react-i18next to handle translations
  // const parkingDuration = totalDuration > 120 ? (days > 0 ? days + `d, ` : ``) + (hours > 0 ? hours + `h, ` : ``) + (minutes + t("m")) : totalDuration.toFixed(0) + ` ` + t("minutes");
  return (
    <Container className="noshadow">
      <ListTable
        formView="normal"
        bulkUplaod={false}
        {...props}
        actions={actions}
        api={`product`}
        itemTitle={`name`}
        shortName={`product`}
        viewDetails={false}
        addPrivilege={true}
        delPrivilege={false}
        updatePrivilege={true}
        attributes={attributes}
        formMode="double"
        popUpUsingId={true}
      ></ListTable>
    </Container>
  );
};
// exporting the page with parent container layout..
export default Layout(InvoiceProducts);
